module.exports = __webpack_public_path__ + "img/donate-wechatpay-template.8881ce44.png";